enum MobileAppMessageType {
  AnonymousAccessRequest = 1,
  AuthenticatedAccessRequest = 2,
  NewTokenRequest = 3,
  Ready = 4,
  ReloginRequest = 5,
  PermissionRequest = 6,
  PermissionResponse = 7,
  OpenAppSettings = 8,
}

export default MobileAppMessageType;
